import { render, staticRenderFns } from "./CustomFont.vue?vue&type=template&id=b9d426b8"
import script from "./CustomFont.vue?vue&type=script&lang=ts"
export * from "./CustomFont.vue?vue&type=script&lang=ts"
import style0 from "./CustomFont.vue?vue&type=style&index=0&id=b9d426b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports